import {createContext, useContext, useEffect, useReducer} from "react";
import {useGetShopProdItemInfo} from "../../../api/shopProdItem";
import {useAsyncEffect} from "ahooks";
import {useQueryParam} from "../../../hooks";
import {initialState, reducer, setCount, setSpec, setDetail, setDetailLoading, setSpecModalVisible, setDetailTabActive, setCommentList, setCommentTotal, setCommentQuery,setSeletSkuItem} from "./reducer";
import ls from "../../../utils/ls";
import {useNavigateTo} from "../../../hooks/useNavigateTo";
import useNotice from "../../../hooks/useNotice";
import {useTranslation,getI18n} from "react-i18next";
import cookies from "../../../utils/cookies";
import {useLocation} from "react-router";
import {queryParse} from "../../../utils";
import {useQryShopItemCommentPageForApp} from "../../../api/shopItemComment";

const Context = createContext(initialState);

function GoodsDetailController() {
  const { state, dispatch } = useGoodsDetailContext();
  const { getCommentHandle } = useQryShopItemCommentPageForApp();
  const { detail, spec, count, commentQuery } = state;
  const { t } = useTranslation();
  const navigateTo = useNavigateTo();
  const notice = useNotice();
  const lang = getI18n().language;
  
  /**
   * 获取评价列表
   * @param query
   * @returns {Promise<void>}
   */
  const getComment = async (query) => {
    let q = {
      ...commentQuery,
      ...query
    };
    if (detail.itemId) {
      q.itemId = detail.itemId;
    }
    
    let { data } = await getCommentHandle(q);
    
    if (data) {
      dispatch(setCommentList(data.records));
      dispatch(setCommentTotal(data.total));
      dispatch(setCommentQuery(q));
    }
  };
  
  /**
   * 加减 商品数量
   * @param type
   */
  const countHandle = (type) => {
    let res = state.count;
    type === 'add' ? res += 1 : res -= 1;
    dispatch(setCount(res));
  };
  
  /**
   * 提交订单
   * @param cb
   */
  const gotoConfirmOrder = (cb) => {
    if (!spec.specSkuId) {
      return notice.warn(t('请选择规格'));
    }
 
    let q = [
      {
        shopId: detail.shopId,
        goodsList: [
          {
            itemId: detail.itemId,
            itemSkuId: spec.specSkuId,
            mainPicView: detail.mainPicView,
            preferPrice: detail.preferPrice || 0,
            price: spec.price,
            productName: detail.itemName,
            productEnName: detail.itemEnName,
            quantity: count,
            specName: spec.specName,
          }
        ],
        shopMainPicView: '',
      }
    ];
    
    let urlQuery = {
      redirect: '/confirmOrder',
    };
    
    ls.setConfirmGoodsList(q);
    navigateTo('/confirmOrder');
    // if (cookies.getToken()) {
    //   navigateTo('/confirmOrder');
    // } else {
    //   navigateTo('/visitorLogin' + queryParse({
    //     ...urlQuery,
    //     visitor: 1,
    //   }));
    // }
    
  };
  
  /**
   * 选择规格
   * @param item
   */
  const selectSpec = (item) => {
    dispatch(setSpec(item));
  };


  const setSkuItem = (item, index, cindex) => {
    let _t = Object.assign([], state.skuItem);
    _t[index] = {
      specName: item.specName,
      specValue: item.specNameValueList[cindex],
    };
    dispatch(setSeletSkuItem(_t));

    let _a = _t.map((item) => {
      return item.specName + ":" + item.specValue;
    });
    let specName = _a.join(";");

    let _item = detail.specListRes.find((item) => {
      return specName === item.specName;
    });

    if (_item) {
      selectSpec(_item);
    }
  };
  
  /**
   * 商品规格modal // 手机端
   * @param payload
   * @private
   */
  const _setSpecModalVisible = (payload) => {
    dispatch(setSpecModalVisible(payload));
  };

  const _setDetailTabActive = (active) => {
    dispatch(setDetailTabActive(active));
  };
  
  return {
    countHandle,
    gotoConfirmOrder,
    selectSpec,
    setSkuItem,
    getComment,
    setSpecModalVisible: _setSpecModalVisible,
    setDetailTabActive: _setDetailTabActive
  };
}

function useGoodsDetailContext() {
  const { state, dispatch } = useContext(Context);
  
  return {
    state,
    dispatch,
  };
}

function GetGoodsDetail({ children }) {
  const [goodsId] = useQueryParam('goodsId');
  const { loading, getDetail } = useGetShopProdItemInfo({ itemId: goodsId });
  const { dispatch } = useGoodsDetailContext();
  const { getComment } = GoodsDetailController();
  
  // 通过 async 同步获取值，否则拿不到值
  // 不能通过监听deps 获取值，否则会无限循环
  useAsyncEffect(async () => {
    let { data } = await getDetail();
    if (data) {
      document.title = data?.itemName;
      dispatch(setDetail(data));
      getComment({ itemId: data.itemId });
    }
  }, []);
  
  useEffect(() => {
    dispatch(setDetailLoading(loading));
  }, [loading]);
  
  return (children);
}

export {useGoodsDetailContext, GoodsDetailController};

export default function GoodsDetailContext({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  
  return (
    <Context.Provider
      value={{ state, dispatch }}
      reducer={reducer}>
      <GetGoodsDetail>
        {children}
      </GetGoodsDetail>
    </Context.Provider>
  );
}
